import {put, takeLatest, call} from 'redux-saga/effects';
import * as tableService from "../../../services/tableService.js";
import {
    UNDELETE_TABLE,
    GET_TABLES_SUCCESS,
    UNDELETE_TABLE_ERROR,
}
    from "../../actions/table";

function* unDeleteTableSaga(action) {
    try {
        yield call(tableService.UnDeleteTable, action.payload)
        yield put({
            type: GET_TABLES_SUCCESS,
            payload: action.payload._id
        });

    } catch (error) {
        yield put({
            type: UNDELETE_TABLE_ERROR,error: error.data
        });
    }
}


export function* unDeleteTableSagaWatcher() {
    yield takeLatest(UNDELETE_TABLE, unDeleteTableSaga);
}